'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _AccordionItemBody = require('./AccordionItemBody.scss');

var _AccordionItemBody2 = _interopRequireDefault(_AccordionItemBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccordionItemBody = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(AccordionItemBody, _Component);

  function AccordionItemBody() {
    (0, _classCallCheck3.default)(this, AccordionItemBody);
    return (0, _possibleConstructorReturn3.default)(this, (AccordionItemBody.__proto__ || (0, _getPrototypeOf2.default)(AccordionItemBody)).apply(this, arguments));
  }

  (0, _createClass3.default)(AccordionItemBody, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          wrapperClassName = _props.wrapperClassName,
          uuid = _props.uuid,
          children = _props.children,
          maxHeight = _props.maxHeight,
          overflow = _props.overflow,
          duration = _props.duration;

      var ariaLabelledBy = 'enterprise-accordion-item-title-' + uuid;
      var id = 'enterprise-accordion-item-body-' + uuid;
      var _className = (0, _classnames2.default)(className, _AccordionItemBody2.default.root);
      var style = { maxHeight: maxHeight, overflow: overflow, transition: 'max-height ' + duration + 'ms ease' };

      return _react2.default.createElement(
        'div',
        { 'aria-labelledby': ariaLabelledBy, id: id, className: _className, style: style },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(wrapperClassName, _AccordionItemBody2.default.wrapper) },
          children
        )
      );
    }
  }]);
  return AccordionItemBody;
}(_react.Component), _class.propTypes = {
  /* MaxHeight style applied to the component */
  maxHeight: _react.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]),
  /* Duration of the transition */
  duration: _react.PropTypes.number,
  /* Overflow style applied to the component */
  overflow: _react.PropTypes.string,
  /* Unique identifier of the item */
  uuid: _react.PropTypes.string,
  /* Content of the body */
  children: _react.PropTypes.node,

  /* Callback for when item title is clicked */
  onClick: _react.PropTypes.func,

  /* Custom className applied to root item div */
  className: _react.PropTypes.string,
  /* Custom className applied to the accordion item body wrapper */
  wrapperClassName: _react.PropTypes.string
}, _temp);
exports.default = AccordionItemBody;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseAccordion/AccordionItemBody/AccordionItemBody.jsx
// module id = 655
// module chunks = 0